<script lang="ts">
	export let parent = '';
	const inCarousel = parent === 'carousel';
</script>

<article class="px-slab" class:inCarousel>
	<div class="px-slab-inner">
		<slot />
	</div>
</article>

<style>
	article {
		display: flex;
		position: relative;
		flex: 30%;
		flex-flow: column nowrap;
		align-self: stretch;
		block-size: auto;

		/* width: 350px; */
		min-inline-size: 200px;
		margin-block: var(--gutterMedium);
		background-color: var(--streamBackgroundColor);
		box-shadow: var(--content-shadow);
	}

	.inCarousel {
		margin-block: 0;
	}

	article:hover {
		box-shadow: var(--hovered-content-shadow);
	}

	.px-slab-inner {
		display: flex;
		flex-flow: column nowrap;
		block-size: 100%;
		inline-size: 100%;
	}
</style>
